<template>
  <div class="paper-container" style="display: flex">
    <div class="side">
      <!-- <Learning
        :dataList="dataList"
        title="学术精汇"
        @learnClick="handleLearn"
        @requestAll="handleAll4"
      ></Learning> -->
      <div class="subject">
        <Subject @subClick="handleSub" @requestAll="handleAll"></Subject>
      </div>
      <Include
        :sideList="includeList"
        @includeClick="handleInclude"
        @requestAll="handleAll1"
      ></Include>
      <Year
        :sideList="yearList"
        @yearClick="handleYear"
        @requestAll="handleAll2"
      ></Year>
    </div>
    <div class="content" v-if="itemList.length > 0 || scrollFlag">
      <Item
        v-for="(v, i) in itemList"
        :key="i"
        :curcer="v.articleId"
        :every="v"
        @itemClick="goDetail(v)"
      ></Item>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
    </div>
    <NoData v-else></NoData>
  </div>
</template>

<script>
import Subject from "@/components/pager/Subject.vue";
import Include from "@/components/pager/Include.vue";
import Year from "@/components/pager/Year.vue";
// import Learning from "@/components/pager/Learning.vue";
import Item from "@/components/pager/Item";
import mixin from "@/mixins/esIndex";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    Item,
    Include,
    Year,
    // Learning,
    Subject,
    Scroll,
    NoData
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        articleType: 0,
        name: "论文",
        type: 0,
        paramStr: this.$route.query.paramStr,
        searchType:this.$route.query.searchType,
      },
      dataList: ["是", "否"],
    };
  },
  created() {
    this.getSearchList(this.params);
    this.getIncludeList(); // 收录
    this.getYearList(); // 年份
  },
  watch: {
    "$route.query"(newVal) {
      // 论文列表
      this.getSearchList({
        ...this.params,
        paramStr: newVal.paramStr,
      }); // 当地址栏变化就调用接口
    },
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "details",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-tree-empty {
  margin: 30px;
}
.subject {
  height: 559px;
  background-color: #fff;
  margin-bottom: 9px;
  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .ivu-tree {
    margin: 0 13px;
  }
}
.side {
  width: 300px;
  margin-right: 11px;
}
.content {
  width: 890px;
}
</style>
